import { action, runInAction } from "mobx";
import { MrbBasePreviewViewStore } from "mrb/core";

class LoadioArtistPreviewViewStore extends MrbBasePreviewViewStore {
    constructor(rootStore, { routeStore }) {
        const id = rootStore.routerStore.routerState.params.id;
        super(rootStore, {
            id: id,
            navigateBack: "master.administration.loadio.artist.list",
        });
        this.routeStore = routeStore;
    }

    get(id) {
        return this.routeStore.getLoadioArtist(id);
    }

    @action.bound
    async toggleIsActive(value) {
        const oldValue = this.item.isActive;
        this.item.isActive = value;
        try {
            await this.routeStore.updateActiveStatus(this.item.id, this.item.isActive);
        } catch (err) {
            runInAction(() => {
                this.item.isActive = oldValue;
                this.rootStore.notificationStore.error("Unexpected error occurred. Unable to change status", err);
            });
        }
    }
}

export default LoadioArtistPreviewViewStore;
